module.exports = __webpack_public_path__ + "static/media/service-scenario-bg2.7ed81b3d.png";